import axios from 'axios'
import baseURL from '@/plugins/http/baseURL'
import Loading from 'vue-loading-overlay'

export default {
  data: function () {
    return {
      actions: false,
      isLoading: false,
      onCancel: true,
      fullPage: true
    }
  },
  props: {
    file: {
      type: Object,
      require: true
    }
  },
  components: {
    Loading
  },
  methods: {
    forceFileDownload (response, file) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', file.description.replace(/\s/g, '') + `.${file.files[0].extension}`)
      document.body.appendChild(link)
      link.click()
    },
    downloadFile (file) {
      this.isLoading = true
      axios({
        method: 'post',
        url: baseURL + '/v1/dweller/file/download',
        data: {id: file.files[0].id},
        responseType: 'arraybuffer'
      })
      .then(response => {
        this.forceFileDownload(response, file)
        this.isLoading = false
      })
      .catch(() => {
        this.$toast.error('Arquivo não pode ser localizado.')
        this.isLoading = false
      })
    },
    viewActions (status) {
      if (status) {
        this.actions = false
      } else {
        this.actions = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/files/index/components/resources/index.js